// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3OJDN","colMaxWidth":"Table_colMaxWidth__3tLKw"};